import vue from 'vue'
import Vuex from 'vuex'

vue.use(Vuex)
export default new Vuex.Store({
    state: {
        customer: false,
        userInfo: false,
        unknownState: -1, //未知/其他
        diaryState: 0,    //日记
        goodsState: 1,    //商品
        homeState: 2,     //首页
        questionState: 3, //问答
        activityState: 4, //活动
        doctorState: 5,   //医生/专家
        wechatSignUrl: ""
    },
    mutations: {
        setCustomerStatus(state, boolStatus) {
            state.customer = boolStatus;
        },
        setUserInfo(state, status) {
            state.userInfo = status;
        },
        setWechatSignUrl(state, wxSignUrl) {
            // 关键点
            // IOS仅记录第一次进入页面时的URL
            // IOS微信切换路由实际URL不变，只能使用第一进入页面的URL进行签名
            if (isIos() && state.wechatSignUrl !== '') {
                return;
            }
            state.wechatSignUrl = wxSignUrl;
        }
    }
})


function isIos() {
    const u = navigator.userAgent;
    return u.indexOf("iPhone") > -1 || u.indexOf("Mac OS") > -1;
}




//////////////////
// WEBPACK FOOTER
// ./static/js/store.js
// module id = Y6vn
// module chunks = 52